/*
 * @Author: Victor
 * @Date: 2023-12-28 14:36:49
 * @LastEditors: Gaho
 * @LastEditTime: 2024-12-18 16:50:30
 * @Description: plinko游戏的自动投注(待优化)
 * @description:
 * 自动投注:
 *  - 此方法為遞迴循環與autoOptionStore的交互,會根據autoOptionStore的設定自動投注
 *  - 必須傳入oForm ,主要交互amount,isSubmiting , isSubmiting 如果為false 會停止遞迴
 *  - 必須傳入遊戲下注函式, 必須為async 方法
 * 使用方法:
 *    只需使用startInfinity()開始投注，使用stopInfinity()停止投注,
 * 
 * 复用公共方法，修改startInfinity、stopInfinity、infiniting
 * 💥  👇 💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥💥 
 * 当前文件已经废弃，已经改用： common\js\bettingToolkit\auto.ts 
 * 
 */

import { useAutoOptionStore } from '~/stores/cansino/autoOption';
import type { FormObject } from '@/common/js/bettingToolkit/index';
import { useUserStore } from '~/stores/user';
import { usePlinkoStore } from '~/stores/cansino/plinko';
import useSettingsStore from '~/stores/settings';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { getGameName } from '@/common/js/gameAbout';
import { Notify } from 'quasar';

const isDev = import.meta.dev;

// ↓ 调用方需要回报的信息
export interface GameResult {
    amount: number; // 下注金额
    winAmount: number; // 赢钱金额（可以是0）
    [key: string]: any; // 其它任意值
}

type FnIncrease = (multiple: number) => number;
type FnReset = () => number;

interface Config {
    fnIncrease?: FnIncrease; // 用于 roulette 
    fnReset?: FnReset; // 用于 roulette 
}

const showTipsForNoMoney = () => {

}
export const useAutoBetToolKit = (
    oForm: FormObject,
    betSubmit: () => Promise<GameResult>,
    oConfig: Config = {}, // ← 特定的游戏需要配置，如 roulette
) => {
    const plinkoStore = usePlinkoStore();
    const joinStateStore = useJoinStateStore();
    const userStore = useUserStore();
    const autoOption = useAutoOptionStore();
    // ↑ 各个 stores ----------------------------------------------
    // ↓ 注意，以下几项在 startInfinity() 内部“都” 应被赋初始值 
    let gameRegistered = ''; // 记录自动下注的启动位置（游戏名）
    let planBetTimes = 0; // 计划下注次数（0表示无限次）
    let betPerformed = 0; // 已经下注次数
    let orignalAmount = 0; // 用來记录初始金額（自动模式启动时的金额）
    let accumulateVal = 0; // 历次游戏输赢金额求和（每局累加） 
    const accumulateArr = []; // 历次游戏输赢金额列表
    const historyResult = []; // 保存每局的游戏结果（似乎仅调试用）
    const canStart = ref(plinkoStore.canBet);
    /**
     * 监听plinkoStore.canBet，
     * plinkoStore.canBet = true并且oForm.isSubmiting = true，则开始下注
     */
    watch(() => plinkoStore.canBet, (newVal) => {
        if (useSettingsStore().game.plinko.auto.default) {
            canStart.value = newVal;
            console.log('%cplinkoStore.canBet', 'background-color: #888;color: #fff;font-size:14px;', newVal);
            if (!checkIfGoToStop() && canStart.value) {
                infiniting();
            } else if (checkIfGoToStop() && canStart.value) {
                stopInfinity()
            }
        }
    })

    // ↓ 导出的方法 01，用于“开启” 自动模式
    const startInfinity = () => {
        gameRegistered = getGameName(); // 记录初始位置，离开当前游戏要关停自动下注 
        orignalAmount = oForm.amount; // 记录初始金额，执行复位时将调用此金额 
        // -- ↑ 执行一些记录工作，↓ 下方执行一些清空工作 --- 
        accumulateVal = 0;
        betPerformed = 0;
        planBetTimes = Number(autoOption.number) || 0; //0表示不设次数上限
        historyResult.splice(0, 1 / 0);
        accumulateArr.splice(0, 1 / 0);
        oForm.isSubmiting = true;
        autoOption.isAutoBetting = true; // 游戏正在自动下注
        infiniting(); // 开始
        if (isDev) {
            console.log("❇️ 自动下注已经启动 ■■■■■■■■■■■■■■■■");
            console.log("启动位置：", gameRegistered);
            console.log("初始金额：", orignalAmount);
        }
    };

    // ↓ 导出的方法 02，用于“关停” 自动模式（终止递归）
    const stopInfinity = () => {
        // ↓ 添加终止标记，终止 startInfinity() 的执行 
        oForm.isSubmiting = false;
        joinStateStore.gameRunning = false; // 标为游戏已经结束
        autoOption.isAutoBetting = false; // 游戏结束自动下注
    };

    // ---- 👆向外暴露的2个方法 ------------------------------------------------------

    // ↓ 检查是否应当终止自动模式
    const checkIfGoToStop = () => {
        let stopOnProfit = Number(autoOption.stopOnProfit);
        let stopOnLoss = -1 * Number(autoOption.stopOnLoss);
        const fBalance = Number(userStore.oNowCurrency.balance || 0);
        const bLackOfMoney = fBalance < oForm.amount;
        // ↓ 数组中的多个条件，满足的任一，都会终止下注
        const arr = [
            !oForm.isSubmiting, // 自动模式被取消
            !autoOption.isAutoBetting, // 自动模式被取消 02
            gameRegistered != getGameName(), // 已经离开了游戏页
            planBetTimes && (betPerformed >= planBetTimes), // 设定了有限的下注次数 && 已经执行了这些次数
            stopOnProfit && (accumulateVal >= stopOnProfit), // 设定了止盈 && 盈利达标了
            stopOnLoss && (accumulateVal <= stopOnLoss), // 设定了止损 && 损失达标了
            // ------- ↓ 关于金额的相关判断 ----------------------------------------------
            bLackOfMoney, // 余额不足
            !(oForm.amount > 0), // 看似多余，还是写上，以防不测
        ];
        const bResult = arr.some(Boolean);
        // 余额不足时，提示用户
        if (bLackOfMoney && canStart.value) {
            showTipsForNoMoney();
        }
        if (1 && isDev && bResult) {
            console.log('判定得出应当终止下注：\n', arr);
            const aRecord = deepCopy(historyResult);
            const aKeys = [
                'id',
                'sOperation',
                'amount',
                'winAmount',
                'netProfit',
                'nowAccumulate',
            ];
            console.table(aRecord, aKeys);
        }
        return bResult;
    };
    // 主要遞迴（递归）
    const infiniting = async () => {
        if (checkIfGoToStop()) {
            isDev && console.log('已在 auto.ts 内部结束自动下注');
            stopInfinity();
            return;
        }
        joinStateStore.gameRunning = true; // 标为游戏进行中
        decreaseAutoOptionNumber(); // 更新待下注的局数，例如 3 => 2
        const { sOperation } = setNewBetAmount(); // 设定新的赌金或金额复位 
        const sOrder = `${betPerformed}/${planBetTimes}`;
        if (isDev) {
            console.log(`■ 第 ${sOrder} 局开始 ======================`);
        }
        // ↓ 执行下注，并等待调用方宣告本局游戏已经结束，并返回游戏结果
        joinStateStore.gameBetFinished = false;

        let gameResult = await betSubmit();
        joinStateStore.gameBetFinished = true;
        if (!gameResult || gameResult?.error) {
            return stopInfinity(); // 下注失败了，终止
        }
        const { winAmount = 0 } = gameResult;
        // ↓ 净利润，可为负数
        // ↓ 经查证，此值为正视为赢(Win)，即返现不算赢，返现金额大于押注金额才是赢 
        const netProfit = winAmount - gameResult.amount;
        accumulateVal += netProfit;
        accumulateArr.push(netProfit);
        if (isDev) {
            console.log(`#${sOrder} 返回结果如下\n`, deepCopy(gameResult));
            const sum = accumulateArr.reduce((result, cur) => result + cur);
            if (sum != accumulateVal) debugger;
        }
        if (isDev) {
            gameResult = {
                ...gameResult, // 拷贝，防止数据被外界污染
                netProfit,
                sOperation, // 用于调试：表示操作细节 
            };
            historyResult.push(gameResult);
            gameResult.nowAccumulate = accumulateVal;
            console.log(
                `第 ${sOrder} 局结束，输赢总计：${accumulateVal}, 详情如下：\n`,
                deepCopy(accumulateArr), '\n',
                deepCopy(historyResult),
            );
        }
        await Sleep(200); // 间隔一点点
        if (canStart.value) {
            await infiniting();  // 递归调用
        }
    };

    // ▼ 计数器：每次循環，檢查次數是否要停止
    const decreaseAutoOptionNumber = () => {
        betPerformed++; // 将已经执行的局数加一
        // ↓ 这是 store 中用户输入的自动下注次数，有可能为空 
        const autoBetsNum = Number(autoOption.number);
        if (autoBetsNum > 0 === false) return;
        // 👇 将待执行的局数（轮次）减一
        autoOption.setState({
            number: (autoBetsNum - 1).toString(),
        });
    };
    // 👇 设定上涨后的赌金值，或金额复位（回归初始值）  
    const setNewBetAmount = () => {
        const { onWinReset, onLossReset } = autoOption;
        const maxBetAmount = Number(autoOption.maxBetAmount);
        const onWin = Number(autoOption.onWin); // 用户设定的赢时上涨金额 
        const onLoss = Number(autoOption.onLoss);
        // === ↑ 先在顶部把 store 中的值取出来 =================================== 
        const previousVal = accumulateArr.at(-1); // 上局赢钱金额（第1局自然取不到上局的值，因此必然不会执行上涨）
        const hasWon = previousVal > 0; // 上局“赢” 了 
        const hasLost = previousVal < 0; // 上局“输” 了 

        // === ↑ 统计上局的输赢情况 =================================== 
        // === ↑ 以上全是用于得出结论的客观数据 ========================================= 
        let mutiple = 1; // 目标倍数，默认为 1，表示不涨
        let toReset = false; // 值为 true 表示需要将金额复位 
        // ======= ↓ 上局赢了 😊 ===================== 
        if (hasWon) {
            if (onWinReset) { // 用户“明确要求” 金额复位，此时不管上涨值设为多少都不涨  
                toReset = true;
            } else if (onWin > 0) { // 至此表示用户“不要”金额复位，继续判断用户是否提供了上涨比例
                mutiple += onWin / 100;
            }
        }
        // ======= ↓ 上局输了 💀 ===================== 
        else if (hasLost) {
            if (onLossReset) {
                toReset = true;
            } else if (onLoss > 0) {
                mutiple += onLoss / 100;
            }
        }

        let newVal = ( // 这是新的金额（初步值，因为下方会校验此值） 
            toReset
                ? orignalAmount // 复位值
                : oForm.amount * mutiple // 上涨值
        );
        // 上涨原因（赢or输）用于调试 
        let sOperation = (() => {
            if (!isDev) return '';
            if (!accumulateArr.length) return '开局';
            let sResult = '上局' + (hasWon ? '赢😊' : (hasLost ? '输💀' : '平□'));
            sResult += '拟在本局：金额 ';
            sResult += (
                toReset
                    ? `Reset to ${orignalAmount}`
                    : `x ${mutiple.toFixed(2)} = ${newVal}`
            );
            return sResult;
        })();
        // ↓ 下面对 newVal 进行多重验证 
        // ↓ 即使现在 mutiple === 1 也需要继续验证，因为其值可能超过用户余额 
        if ((newVal > maxBetAmount) && (maxBetAmount > 0)) {
            // 不能超过设定的上限
            newVal = maxBetAmount;
        }
        if (newVal > userStore.oNowCurrency.balance) {
            // 不能超过用户的余额
            newVal = userStore.oNowCurrency.balance;
        }
        
        if (newVal > joinStateStore.betttingLimits.maxBets[0]) {
            // 不能超过游戏规则的金额上限
            newVal = joinStateStore.betttingLimits.maxBets[0];
        }
        oForm.amount = Number(getFixed(newVal, 2));
        return { sOperation };
    };

    return {
        stopInfinity,
        startInfinity,
    };
};
